module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1271 100.06\"><title>test-top-white</title><g id=\"25fe1019-5f21-4b11-943c-710a069b77bd\" data-name=\"Layer 4\"><path d=\"M0,100.18C512.16,23.86,908,.17,1270.67.17c.74,0,0,100,0,100Z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/social-top-white.svg
// module id = 575
// module chunks = 1